// extracted by mini-css-extract-plugin
export default {"project":"Projects_project__7QZum","card":"Projects_card__AAoVy","imgCard":"Projects_imgCard__GsOnS"};